import { Directive, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { MatAutocomplete } from '@angular/material/autocomplete';
import { MatInput } from '@angular/material/input';
import { Subject, Observable, of } from 'rxjs';
import { tap, takeUntil, map, switchMap, startWith, exhaustMap, concatMap } from 'rxjs/operators';

export interface IAutoCompleteScrollEvent {
  autoComplete: MatAutocomplete;
  scrollEvent: Event;
}

export interface IInfinityScrollEvent {
  page: number;
  options: any[];
  size: number;
}

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: 'mat-autocomplete[infinityScroll]',
  exportAs: 'infinityScroll'
})
export class InfinityScrollDirective implements OnDestroy {

  @Input() thresholdPercent: number = .8;
  private _infinityScroll$: Subject<any[]> = new Subject();
  private _options: any[];
  public items: Observable<any[]>;
  private nextPage$: Subject<any> = new Subject();
  private reduceOptions: any[] = [];
  private currentPage: number = 0;
  private size: number = 20;
  private recordSearch: string = '';
  private _infinityModel: MatInput;
  @Input() isRecordSearch: boolean;
  @Input('infinityModel')
  set industryModel(element: MatInput) {
    this.initSubscription(element, this.options);
  }

  get infinityModel() {
    return this._infinityModel;
  }
  @Input('infinityScroll')
  set infinityScroll(_options: any[]) {
    this.initSubscription(this.infinityModel, _options);
  }

  @Output() scrollRecordSearch: EventEmitter<number> = new EventEmitter();

  get options() {
    return this._options;
  }
  _onDestroy: Subject<any> = new Subject();


  initSubscription(element: MatInput, options: any) {
    this._infinityModel = element;
    this._options = options;
    if (element && options) {
      if (!this.isRecordSearch) {
        this.items = this._infinityModel.ngControl.valueChanges
        .pipe(
          startWith(''),
          map((value: string) => value ? value : ''),
          map((value: string) => {
            if (value &&
              this._options.filter((item: any) => (item.value || item).toLowerCase().indexOf(value.toLowerCase()) >= 0).length > 0) {
              return this._options.filter((item: any) => (item.value || item).toLowerCase().indexOf(value.toLowerCase()) >= 0);
            } else {
              return this._options;
            }
          }),
          tap(() => this.currentPage = 0),
          tap(() => this.reduceOptions = []),
          tap(() => this.autoComplete._setScrollTop(0)),
          switchMap((ops: any[]) => {
            return this.nextPage$.pipe(
              startWith(this.currentPage),
              exhaustMap(() => of(ops.slice(this.currentPage * this.size, this.currentPage * this.size + this.size))),
              tap(() => this.currentPage++),
              // scan((allProducts, newProducts) => allProducts.concat(newProducts), []),
              map((newOptions: any[]) => this.reduceOptions = this.reduceOptions.concat(newOptions))
            );
          })
        );
        // scroll end of list
      } else {
        this.items = this._infinityModel.ngControl.valueChanges
        .pipe(
          startWith(''),
          concatMap(() => {
            const ops = this._options;
            if (element.value && (this.recordSearch !== element.value)) {
              this.currentPage = 0;
              this.reduceOptions = [];
              this.autoComplete._setScrollTop(0);
              this.recordSearch = element.value;
            }
            return this.nextPage$.pipe(
              startWith(this.currentPage),
              exhaustMap(() => {
                if ((ops.length > this.reduceOptions.length) || (this.reduceOptions.length === 0)) {
                  this.reduceOptions = ops;
                  this.currentPage = this.currentPage + 1;
                } else {
                  this.scrollRecordSearch.emit(this.currentPage * this.size);
                }
                return of(this.reduceOptions);
              }),
            );
          })
        );
      }
    }
  }
  constructor(public autoComplete: MatAutocomplete) {
    this.autoComplete.opened.pipe(
      tap(() => {
        // Note: When autocomplete raises opened, panel is not yet created (by Overlay)
        // Note: The panel will be available on next tick
        // Note: The panel wil NOT open if there are no options to display
        setTimeout(() => {
          // Note: remove listner just for safety, in case the close event is skipped.
          this.removeScrollEventListener();
          this.autoComplete.panel.nativeElement
            .addEventListener('scroll', this.onScroll.bind(this));
        });
      }),
      takeUntil(this._onDestroy)).subscribe();

    this.autoComplete.closed.pipe(
      tap(() => {
        this.currentPage = 0;
        this.reduceOptions = [];
        this.nextPage$.next();
        this.removeScrollEventListener();
      }),
      takeUntil(this._onDestroy)).subscribe();
  }

  private removeScrollEventListener() {
    if (this.autoComplete.panel) {
      this.autoComplete.panel.nativeElement
        .removeEventListener('scroll', this.onScroll);
    }
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
    this.nextPage$.complete();
    this._infinityScroll$.complete();
    this.removeScrollEventListener();
  }

  onScroll(event: Event) {

    if (this.thresholdPercent === undefined) {
      // this.scroll.next({ autoComplete: this.autoComplete, scrollEvent: event });
    } else {
      const threshold = this.thresholdPercent * 100 * event.target['scrollHeight'] / 100;
      const current = event.target['scrollTop'] + event.target['clientHeight'];
      if (current > threshold) {
        // this.scroll.next({ autoComplete: this.autoComplete, scrollEvent: event });
        this.nextPage$.next();

      }
    }
  }
}
